// RTF 剪贴板的保守安全边界。
//
// RTF 比 HTML 更接近系统原始格式，部分应用会把字段、DDE、对象或外部
// 文件引用一起放进剪贴板。LinkDesk 只转发没有这些高风险能力的普通排版
// RTF；遇到无法确认安全的内容时由调用方回退到 HTML 或纯文本。

export const MAX_CLIPBOARD_RTF_LENGTH = 512 * 1024;

// 这些控制字可能携带可执行字段、外部文件、嵌入对象、二进制图片或动态
// 数据。保守拒绝整段 RTF，让 text/plain / text/html 继续工作。
const UNSAFE_CONTROL_WORD = /\\(?:field|fldinst|ddef|dde|ddeauto|datafield|datastore|themedata|object|objdata|objclass|objname|file|filetbl|template|pict|wmetafile|emfblip|pngblip|jpegblip|macpict|bin|htmltag|shp|shpinst|shprslt)(?=[^a-z]|$)/i;

function hasBalancedGroups(value: string): boolean {
  let depth = 0;
  let escaped = false;
  for (const char of value) {
    if (escaped) {
      escaped = false;
      continue;
    }
    if (char === '\\') {
      escaped = true;
      continue;
    }
    if (char === '{') {
      depth += 1;
    } else if (char === '}') {
      depth -= 1;
      if (depth < 0) return false;
    }
  }
  return depth === 0 && !escaped;
}

/**
 * 保留常见字体、颜色、字号、粗体、斜体、下划线和段落布局等 RTF 信息。
 * 对字段/对象/二进制数据采用整段拒绝策略，避免把危险能力带到目标应用。
 */
export function sanitizeClipboardRtf(value: unknown): string {
  if (typeof value !== 'string' || !value.trim()) return '';
  if (value.length > MAX_CLIPBOARD_RTF_LENGTH) return '';
  if (value.includes('\u0000')) return '';
  const rtf = value.trim();
  if (!/^\{\s*\\rtf\d(?:\s|\\|\{|$)/i.test(rtf)) return '';
  if (!hasBalancedGroups(rtf)) return '';
  if (UNSAFE_CONTROL_WORD.test(rtf)) return '';
  return rtf;
}
